function cyclingTripsWidgetPlacesApiInit() {
  jQuery('.widget_cycling-trips-search .location-search-submit').click(
    function (e) {
      e.preventDefault();
      var t = jQuery(this);
      var form = t.parents('form');
      var baseUrl = form.attr('action');
      if (GLSearch.selected.placeId) {
        var args = {
          placeId: GLSearch.selected.placeId,
          placeName: GLSearch.selected.placeName,
        };
        var url = baseUrl + '?' + buildUrl(args);
        window.location.href = url;
      }
    }
  );

  function buildUrl(data) {
    var ret = [];
    for (var d in data)
      ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
    return ret.join('&');
  }
}

if (document.placesApiLoaded) {
  cyclingTripsWidgetPlacesApiInit();
} else {
  document.addEventListener('placesApiLoaded', cyclingTripsWidgetPlacesApiInit);
}
